import React from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ComingSoonBanner from '../components/ComingSoonBanner';

const Video = () => {
  const { user } = useAuth();

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              🎬 Módulo de Video
            </h1>
            <p className="text-gray-600 dark:text-gray-300">
              Crea videos profesionales con inteligencia artificial
            </p>
          </div>

          <ComingSoonBanner
            title="Módulo de Video - Próximamente"
            description="Este módulo está en desarrollo activo con las tecnologías más avanzadas de generación de video con IA. Pronto podrás crear videos desde texto, editar automáticamente con IA y producir contenido audiovisual profesional."
            estimatedDate="Febrero 2025"
          />

          <div className="bg-white dark:bg-[#1a2530] rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              Características Próximas
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">📝 Texto a Video</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Genera videos completos a partir de descripciones de texto
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">✂️ Edición Automática</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Edita videos profesionalmente con IA en segundos
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎭 Guión a Video</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Crea videos narrativos completos desde guiones
                </p>
              </div>
            </div>
            
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-6">
              <h3 className="font-bold text-blue-900 dark:text-blue-300 mb-3">
                ✨ Funcionalidades Adicionales
              </h3>
              <ul className="space-y-2 text-sm text-blue-800 dark:text-blue-300">
                <li className="flex items-start gap-2">
                  <span>✓</span>
                  <span>Agregar voces en off y narración automática</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>✓</span>
                  <span>Música de fondo generada con IA</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>✓</span>
                  <span>Efectos visuales y transiciones profesionales</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>✓</span>
                  <span>Múltiples resoluciones y formatos de exportación</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Video;
